import { useSelector } from 'react-redux';
import { AccessLevel } from '@dev/ee-api/ee-api-models';

import { getConfigStore } from '@api/store/config/actions';
import { useSecurity } from '@api/services/hooks/useSecurity';
import { getGeneralInfo } from '@api/store/account/actions';

export const useUpselling = (requiredAccessLevels?: AccessLevel) => {
    const { IsUser, IsSub, AccountAccessLevel } = useSelector(getGeneralInfo);
    const { bootedAsChild, isStandalone } = useSelector(getConfigStore);
    const { hasLegacyPlan } = useSecurity();

    const planRestrictions = !hasLegacyPlan && !IsUser && !IsSub;
    const productRestrictions = bootedAsChild || isStandalone;

    const accessLevelRestrictions = !AccountAccessLevel?.includes(requiredAccessLevels);

    const isUpsellingVisible = productRestrictions && planRestrictions && accessLevelRestrictions;

    return {
        isUpsellingVisible,
    };
};
